import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import ProgressBar from '../ProgressBar/ProgressBar';
import { PLACEHOLDER_COURSE_IMAGE } from '../../constants';
import { formatCoursePrice } from '../../utils/priceUtils';
import './CourseCard.css';

export default function CourseCard({ course, showProgress = true, showAddToCart = true }) {
  const { addItem: addToCart } = useCart();
  const [added, setAdded] = useState(false);
  const isEnrolled = course.enrolledAt && course.progress !== undefined;
  const progress = course.progress ?? 0;

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(course);
    setAdded(true);
  };

  return (
    <article className="course-card">
      <Link to={`/course/${course.id}`} className="course-card-link">
        <div className="course-card-image-wrap">
          <img
            src={course.thumbnail || PLACEHOLDER_COURSE_IMAGE}
            alt=""
            className="course-card-image"
            onError={(e) => { e.target.onerror = null; e.target.src = PLACEHOLDER_COURSE_IMAGE; }}
          />
          {isEnrolled && showProgress && (
            <div className="course-card-progress-wrap">
              <ProgressBar value={progress} height={4} />
            </div>
          )}
        </div>
        <div className="course-card-body">
          <h3 className="course-card-title">{course.title}</h3>
          <p className="course-card-instructor">by {course.instructor}</p>
          <div className="course-card-meta">
            <span className="course-card-level">{course.level}</span>
            <span className="course-card-dot">·</span>
            <span className="course-card-duration">{course.duration}</span>
          </div>
          {course.rating != null && (
            <p className="course-card-rating">
              <span className="course-card-rating-value">{course.rating}</span>
              {course.reviewCount != null && (
                <span className="course-card-review-count"> ({course.reviewCount.toLocaleString()})</span>
              )}
            </p>
          )}
          <p className="course-card-price">{formatCoursePrice('Free')}</p>
        </div>
      </Link>
      {isEnrolled && showProgress && (
        <div className="course-card-footer">
          <span className="course-card-progress-text">{progress}% complete</span>
          <Link to={`/course/${course.id}/learn`} className="course-card-resume">
            {progress > 0 ? 'Continue' : 'Start'}
          </Link>
        </div>
      )}
      {!isEnrolled && showAddToCart && (
        <div className="course-card-footer">
          <button type="button" className="course-card-add-to-cart" onClick={handleAddToCart}>
            {added ? 'Added to cart' : 'Add to cart'}
          </button>
        </div>
      )}
    </article>
  );
}
